import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationScoreFinanceiroGeral(year?: number) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-score-financeiro-geral', year],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_FINANCEIRO_GERAL, year ? String(year) : undefined),
  });
}

export { useConsolidationScoreFinanceiroGeral };
